import React from 'react'
import { Result } from 'antd-mobile'

function Error({ message = '服务器开小差了~~~' }) {
  return (
    <Result
      img={<img alt="error" style={{ width: '16.6vw' }} src="" />}
      title=""
      message={message}
    />
  )
}

export default Error
